import { useState } from 'react';
import { AdminGuard } from '../../guards/RolesGuard';
import Navigation from './Navigation';
import { RootState } from '../../app/store';
import { useSelector } from 'react-redux';
import { classNames } from '../../utils/classNames';
import { useTheme } from '../../utils/theme-context';
// import SelectSearchInside from '../../shared/market-select-search/select-inside-search';


const Sidebar = () => {
    const { theme } = useTheme();
    const [search, setSearch] = useState<string>()
    const isAdmin = AdminGuard()

    const onChangePageSearch = (value: string) => {
        setSearch(value)
    }

    const { sidebarTopics } = useSelector(
        (state: RootState) => state.features
    );

    return (
        <div className='hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 dark:border-borderColor-darkMode border-r border-r-1 relative'>
            {!sidebarTopics && <div className='absolute top-0 left-0 w-full h-screen z-10' />}
            <div className={classNames('flex flex-col flex-grow pt-5 bg-white overflow-y-auto dark:bg-bgColor-darkMode', sidebarTopics ? '' : 'opacity-10')}>
                {isAdmin &&
                    <div className='flex items-center flex-shrink-0 px-4'>
                        <form className='max-w-[100%] flex md:ml-0' action='#' method='GET'>
                            <label htmlFor='search-field' className='sr-only'>
                                Search
                            </label>
                            <div className='relative text-gray-400 focus-within:text-gray-600 !max-w-[96%]'>
                                <div className='absolute inset-y-0 left-2 flex items-center pointer-events-none'>
                                    <img alt='search' className='h-4 w-4 dark:h-5 dark:w-5' src={theme === 'dark' ? '/svg/layout/search-icon-white.svg' : '/svg/layout/search-icon.svg'} />
                                </div>
                                <input
                                    id='search-field'
                                    data-qa={'search'}
                                    className='bg-bgColor-search dark:bg-black dark:text-primary-darkMode rounded block w-auto max-w-[99%] pl-8 py-2 border-transparent placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm'
                                    placeholder='Search'
                                    type='search'
                                    name='search'
                                    onChange={(e) => onChangePageSearch(e?.target?.value)}
                                />
                            </div>
                        </form>
                    </div>
                }
                <div className='mt-4 flex-1 flex flex-col'>
                    <nav data-qa={'navigation'} className='flex-1 px-4 pb-4'>
                        <Navigation
                            search={search}
                        />
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default Sidebar;